export default {
  methods: {
    mixinCheckTaxExpires() {
      console.log('mixinCheckTaxExpires check======', this)
      if (
        this.$store.state.app.isProductionTax &&
        this.$store.state.app.productionTaxExpires &&
        new Date().getTime() > this.$store.state.app.productionTaxExpires
      ) {
        this.$confirm({
          content: this.$t('order.updateTips'),
          hideClose: true,
          hideCancel: true,
          confirm: () => {
            this.$root.Bus.$emit('payAgain')
          },
        })
        return false
      }
      return true
    },
  },
}
